import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";

export const wsGetOrdenesDigitalesById = (nextStep) => {
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/OrdenDigital/GetByIDPACIENTEQr`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const wsGetGrupoByIdOrden = (id, nextStep) => {
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/OrdenDigital/items/${id}`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const wsGetPDFOrdenEstudio = (id, nextStep) => {
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/OrdenDigital/GetPDF/${id}`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};
